export const getNavigation = state => state.toJS();



// WEBPACK FOOTER //
// ./src/redux/selectors/NavigationSelectors.js